export default __webpack_public_path__ + "static/media/1.641d067c.png";